// Vendors
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

// Styles
import { _Container, _InfoRowTitle, _InfoRowValue, _FlexContainer, _BlockContainer, _PlaceHolder,
  _ValueDiv } from './styles'

const renderContent = ({ tel, url, absolutePath, value, valueDivClass, valueDivClassCss, onValueClick }) => {
  let contents = ''
  if(url || absolutePath) {
    contents = absolutePath && value ?
      <a href={`https://${absolutePath}`} target="_blank" rel="noopener noreferrer">{value}</a>
      : value ?
        <Link to={url} onClick={onValueClick}>{value}</Link>
        : (
          <_ValueDiv className={valueDivClass} valueDivClassCss={valueDivClassCss} onClick={onValueClick}>
            <_PlaceHolder />
          </_ValueDiv>
        )
  } else if(tel) {
    contents = <a href={`tel:${tel}`}>{tel}</a>
  } else if(onValueClick) {
    contents = (
      <_ValueDiv
        clickable
        className={valueDivClass}
        valueDivClassCss={valueDivClassCss}
        onClick={onValueClick}
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{ __html: value }}
      />
    )
  } else {
    contents = (
      <_ValueDiv
        className={valueDivClass}
        valueDivClassCss={valueDivClassCss}
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{ __html: value }}
      />
    )
  }
  return contents
}

const TitleValueBlockV2 = (
  {
    title,
    value,
    url,
    absolutePath,
    tel,
    className = '',
    containerClassCss = '',
    flexContainer = false,
    valueDivClass = '',
    valueDivClassCss = '',
    valueIsLocked,
    titleIsLocked,
    onValueClick,
  }) =>
  (
    <_Container
      css={containerClassCss}
      as={(flexContainer ? _FlexContainer : _BlockContainer)}
      className={className}
    >
      <_InfoRowTitle blur={titleIsLocked}>{title}</_InfoRowTitle>
      <_InfoRowValue blur={valueIsLocked}>
        {renderContent({ valueIsLocked, tel, url, absolutePath, value, valueDivClass, valueDivClassCss, onValueClick })}
      </_InfoRowValue>
    </_Container>
  )

TitleValueBlockV2.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({}), PropTypes.array]),
  url: PropTypes.string,
  absolutePath: PropTypes.string,
  className: PropTypes.string,
  containerClassCss: PropTypes.string,
  valueDivClass: PropTypes.string,
  valueDivClassCss: PropTypes.arrayOf(PropTypes.string),
  tel: PropTypes.string,
  flexContainer: PropTypes.bool,
  valueIsLocked: PropTypes.bool,
  titleIsLocked: PropTypes.bool,
  onValueClick: PropTypes.func,
}

export default memo(TitleValueBlockV2)
